import { Icon } from '@dx-ui/osc-icon';

const FormBulletIcon = () => <Icon name="bullet" size="sm" variant="solid" />;

export { FormBulletIcon };
export default FormBulletIcon;
